interface IOrbitStartupFunctions {
    isCip(): boolean;
    isCis(): boolean;
    isProgressiveWebApp(): boolean;
    logToElastic(eventCategory: string, eventAction: string, eventLabel: string, eventValue: string): void;
    isHybridEmbedded(): boolean;
    getOrbitInitParams(): {
        sdkApiOrigin: string;
        orbitCDNOrigin: string;
        country: string;
        cmsSource: string;
        languageIso3: string;
        languageIso2: string;
        publicationId: number;
        queryParams: string;
    }
}


export const OrbitStartupFunctions = window['orbitStartupFunctions'] as IOrbitStartupFunctions;
